// extracted by mini-css-extract-plugin
module.exports = {"container":"m_x","header":"m_R","title":"m_S","section":"m_l","viewMore":"m_T","titleViewMore":"m_V","imageWrapper":"m_K","cardWrapper":"m_N"};